// @flow
/** @jsx h */
import { Component, Fragment, h } from 'preact';
import CheckEligibility from '../checkEligibilty';
import NonApprovedUserCard from '../nonApprovedUserCard';
import PreApprovedCard from '../preApprovedCard';
import OverlayScreen from '../overlayScreen';
import OverlayEligibiltyCheck from '../overlayEligibiltyCheck';
import { connect } from 'react-redux';
import { useDispatch } from 'react-redux';
import ntbAction from '../../../actions/ntbAction';
import actionType from '../../../actions/ntbAction/actionType';
import { ntbActionType } from '../../../actionTypes';
import { overLayHeights } from '../../../constants';

type Props = {
  uiComponents: Array<BicContentType>,
  pageKey: string,
  bicAction: Function,
  showShowLenderList: boolean,
  getLenderList: Array<LenderDetails>,
  ntbDetails: Object,
  apiState: boolean,
  message: string,
  userStatus: string,
  matches: Object,
  showEligibilityModal: boolean,
  showNonApprovedModal: boolean,
};
class UserStatusCardContainer extends Component<Props, State> {
  handleCloseOverlay = () => {
    const dispatch = useDispatch();
    dispatch({
      type: ntbActionType.CLOSE_ELIGIBILITY_CHECK_MODAL,
      payload: {},
    });
    dispatch(ntbAction(actionType.closeOtpOverLayScreen));
  };

  overlayHeight = overLayHeights.checkEligibleWidgetHeight;
  overlaySizeClassName = 'overlay-wd-medium';

  render() {
    return (
      <Fragment>
        {this.props.userStatus == 'eligible' && (
          <PreApprovedCard
            lenderDetailsList={this.props.ntbDetails.lenderDetailsList}
            matches={this.props.matches}
          />
        )}
        {!this.props.apiState && this.props.userStatus == 'nonLoggedin' && (
          <CheckEligibility />
        )}
        {this.props.userStatus == 'notEligible' && <NonApprovedUserCard />}

        {this.props.showNonApprovedModal && (
          <OverlayScreen
            handleCloseOverlay={this.handleCloseOverlay}
            showOverlay={this.props.showNonApprovedModal}
            overlayHeight={this.overlayHeight}
            overlaySizeClassName={this.overlaySizeClassName}>
            <OverlayEligibiltyCheck
              handleCloseOverlay={this.handleCloseOverlay}
              ntbAction={ntbAction}
            />
          </OverlayScreen>
        )}
      </Fragment>
    );
  }
}

const mapStateToProps = ({ ntbConfig, identifyUser }) => {
  const {
    getLenderList,
    apiState,
    showShowLenderList,
    ntbDetails,
    message,
    userStatus,
    showEligibilityModal,
    showNonApprovedModal,
  } = ntbConfig;
  const { authDetails } = identifyUser;
  const { m: mobile } = authDetails;
  return {
    apiState,
    showShowLenderList,
    getLenderList,
    ntbDetails,
    message,
    userStatus,
    showEligibilityModal,
    showNonApprovedModal,
    mobile,
  };
};

export default connect(mapStateToProps)(UserStatusCardContainer);



// WEBPACK FOOTER //
// ./componentsBICRevamp/buyWithInstacredLanding/userStatusCardContainer/index.js